import type { RouteTitleRule } from '@shared/browserMeta';

export const APP_ROUTE_TITLE_RULES: RouteTitleRule[] = [
  { path: '/investor/how-novaquantis-works', title: 'How NovaQuantis Works' },
  { path: '/investor', title: 'Investor' },
  { path: '/login', title: 'Login' },
  { path: '/simulator', title: 'Simulator' },
  { path: '/portfolio/', title: 'Portfolio' },
  { path: '/portfolio', title: 'Portfolio' },
  { path: '/onboarding', title: 'Onboarding' },
  { path: '/profile/password', title: 'Change Password' },
  { path: '/profile/portfolios/compare/view', title: 'Compare Results' },
  { path: '/profile/portfolios/compare', title: 'Compare Portfolios' },
  { path: '/profile/portfolios', title: 'My Portfolios' },
  { path: '/profile', title: 'Profile' },
  { path: '/user/invite/', title: 'Accept Invite' },
  { path: '/reset-password/', title: 'Reset Password' },
];
